module.exports = __webpack_public_path__ + "static/foodielab-8afbf2f021c0422debfdcd0e273d24dd.png";